import { ContractorContact } from 'shared/types'

export const isTheLastActiveContact = (contacts: ContractorContact[]) =>
  contacts
    ?.reduce(
      (acc: boolean[], { isEmailAddressActive, isPhoneNumberActive }) => {
        return [...acc, isEmailAddressActive, isPhoneNumberActive]
      },
      []
    )
    .filter(item => item).length === 1
